"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsidySubcategories = exports.SubsidySubcategory = exports.SubsidyCategories = exports.SubsidyCategory = void 0;
var SubsidyCategory;
(function (SubsidyCategory) {
    SubsidyCategory["ROAD_CONDITIONS"] = "road_conditions";
    SubsidyCategory["NIGHT_DEPARTURE"] = "night_departure";
    SubsidyCategory["LOW_SUPPLY"] = "low_supply";
    SubsidyCategory["SMART_ASSIGNATIONS"] = "smart_assignations";
    SubsidyCategory["LAST_MINUTE_CHANGES"] = "last_minute_changes";
    SubsidyCategory["OTHER"] = "other";
})(SubsidyCategory || (exports.SubsidyCategory = SubsidyCategory = {}));
exports.SubsidyCategories = {
    [SubsidyCategory.ROAD_CONDITIONS]: "Road Conditions",
    [SubsidyCategory.NIGHT_DEPARTURE]: "Night Departure",
    [SubsidyCategory.LOW_SUPPLY]: "Low Supply",
    [SubsidyCategory.SMART_ASSIGNATIONS]: "Smart Assignations",
    [SubsidyCategory.LAST_MINUTE_CHANGES]: "Last Minute Changes",
    [SubsidyCategory.OTHER]: "Other",
};
var SubsidySubcategory;
(function (SubsidySubcategory) {
    SubsidySubcategory["UNSAFE_ROUTE"] = "unsafe_route";
    SubsidySubcategory["UNEXPECTED_COST"] = "unexpected_cost";
    SubsidySubcategory["OFF_ROAD_ROUTE"] = "off_road_route";
    SubsidySubcategory["HOLIDAY_PERIOD"] = "holiday_period";
    SubsidySubcategory["BLACKLISTED_DATE"] = "blacklisted_date";
    SubsidySubcategory["LOW_COVERAGE"] = "low_coverage";
    SubsidySubcategory["WRONG_PRICING"] = "wrong_pricing";
    SubsidySubcategory["REPLACEMENT_DRIVER"] = "replacement_driver";
    SubsidySubcategory["COMBO_FEE"] = "combo_fee";
    SubsidySubcategory["EARLY_OFFERS_FEE"] = "early_offers_fee";
    SubsidySubcategory["DYNAMIC_FEE"] = "dynamic_fee";
    SubsidySubcategory["WAITING_FEE"] = "waiting_fee";
    SubsidySubcategory["AGREED_LAST_MINUTE_CHANGE"] = "agreed_last_minute_change";
    SubsidySubcategory["OTHER"] = "other";
})(SubsidySubcategory || (exports.SubsidySubcategory = SubsidySubcategory = {}));
exports.SubsidySubcategories = {
    [SubsidyCategory.ROAD_CONDITIONS]: {
        [SubsidySubcategory.UNSAFE_ROUTE]: "Unsafe Route",
        [SubsidySubcategory.UNEXPECTED_COST]: "Unexpected Cost",
        [SubsidySubcategory.OFF_ROAD_ROUTE]: "Off Road Route",
        [SubsidySubcategory.OTHER]: "Other",
    },
    [SubsidyCategory.NIGHT_DEPARTURE]: {},
    [SubsidyCategory.LOW_SUPPLY]: {
        [SubsidySubcategory.HOLIDAY_PERIOD]: "Holiday Period",
        [SubsidySubcategory.BLACKLISTED_DATE]: "Blacklisted Date",
        [SubsidySubcategory.LOW_COVERAGE]: "Low Coverage",
        [SubsidySubcategory.WRONG_PRICING]: "Wrong Pricing",
        [SubsidySubcategory.REPLACEMENT_DRIVER]: "Replacement Driver",
        [SubsidySubcategory.OTHER]: "Other",
    },
    [SubsidyCategory.SMART_ASSIGNATIONS]: {
        [SubsidySubcategory.COMBO_FEE]: "Combo Fee",
        [SubsidySubcategory.EARLY_OFFERS_FEE]: "Early Offers Fee",
        [SubsidySubcategory.DYNAMIC_FEE]: "Dynamic Fee",
        [SubsidySubcategory.OTHER]: "Other",
    },
    [SubsidyCategory.LAST_MINUTE_CHANGES]: {
        [SubsidySubcategory.WAITING_FEE]: "Waiting fee",
        [SubsidySubcategory.AGREED_LAST_MINUTE_CHANGE]: "Agreed to a last-minute change",
        [SubsidySubcategory.OTHER]: "Other",
    },
    [SubsidyCategory.OTHER]: {},
};
//# sourceMappingURL=SubsidyCategory.js.map